import { APP_CFG } from "./constants";
import { createAppStore, getStateValueFromInstance, setStateValueForInstance } from "./state";
import { AppConfiguration, QueryParams } from "./types";
import { getAppInstance, setAppInstance } from "../appContext";

export function initApplicationConfiguration(cfg : AppConfiguration, instanceId : string) : void {
  
  cfg.instanceId = instanceId;
  
  createAppStore(cfg.instanceId)
  console.log("Initializing Application Store with Cfg ", cfg)
  setStateValueForInstance(APP_CFG, cfg, cfg.instanceId);
  setAppInstance(cfg.instanceId);
}

export function finishInitialization(instanceId :string) : void {
  const cfg = getStateValueFromInstance(APP_CFG, instanceId);
  const newCfg = { ...cfg,
    initialized : true
  }    
  setStateValueForInstance(APP_CFG, newCfg, instanceId);
}

export function getAppCfg() : AppConfiguration {  
  return { ...getStateValueFromInstance(APP_CFG, getAppInstance()) };
}

export function setAppCfg(newAppCfg : AppConfiguration) : void {
  setStateValueForInstance(APP_CFG, newAppCfg, newAppCfg.instanceId);
}

export function saveQueryParamsToAppConfiguration(queryParams : QueryParams) : void {
    const appCfg = getAppCfg();
    if (queryParams.projectParamEnabled && queryParams.project?.length > 0) {
      appCfg.projectId = queryParams.project;
    }
    if (queryParams.viewParamEnabled && queryParams.view?.length > 0) {
      appCfg.view = queryParams.view;
    }
    if (queryParams.categoryFilterEnabled && queryParams.categoryFilter?.length > 0) {
      appCfg.category = queryParams.categoryFilter;
    }
    if (queryParams.quest !== undefined && queryParams.quest !== null) {
      appCfg.quest = queryParams.quest;
    }
    //TODO: domain, lang ...
    setAppCfg(appCfg);
}
